export const isInternalRegisteredAsset = (dataSourceType?: string | null) =>
  (dataSourceType ?? "").trim().toUpperCase() === "INTERNAL_REGISTERED";
